import { render, staticRenderFns } from "./ClientMain.vue?vue&type=template&id=31fe8eb6&"
import script from "./ClientMain.vue?vue&type=script&lang=js&"
export * from "./ClientMain.vue?vue&type=script&lang=js&"
import style0 from "./ClientMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports